import { forwardRef } from "react";
import cn from "classnames";

const Textarea: React.FC<any> = forwardRef<any, any>(({ label, error, withAsterisk, ...inputProps }, ref) => {
	return (
		<fieldset className="w-full">
			{label && (
				<label className="block text-sm text-slate-300 mb-1.5">
					{label}
					{withAsterisk && "*"}
				</label>
			)}
			<textarea
				className={cn(
					"w-full px-4 py-3 bg-surface border border-white/10 rounded-lg text-slate-200 placeholder:text-slate-500 focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors resize-y h-36",
					{ "border-red-500 focus:border-red-500 focus:ring-red-500": error }
				)}
				ref={ref}
				{...inputProps}
			></textarea>
			{error && <label className="text-red-400 text-sm mt-1">{error.message}</label>}
		</fieldset>
	);
});

Textarea.displayName = "Textarea";
export default Textarea;
